import { useMutation } from "@tanstack/react-query";

import { DeleteMfaFactorResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";
import { ToastType } from "@/enums/toast";

export const useDeleteMfaFactor = () => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useMutation(
    (): Promise<DeleteMfaFactorResponse> =>
      fetch(ENDPOINTS.mfa.delete, {
        method: "DELETE",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    {
      onSuccess: data => {
        auth?.updateUserState(data.user);
        displayToast("MFA has been disabled successfully", ToastType.success);
      },
      onError: (error: string) => {
        displayErrorToast(error);
      },
    },
  );
};
